export class ErpAdminNoticeTagDto {
    constructor(initializer) {
        this.name = initializer.name;
    }
}
